export class MerchantPrivacy {
  public privacy: string | undefined = undefined;
}
